import { useContext, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { genResource } from 'utilities/api';
import {
  CROPWISE_PROXY_URL,
  CROPWISE_PROXY_V2_URL
} from 'utilities/apiConstants';
import featureFlagRenderItem from 'helpers/featureFlagRenderItem';
import { Context } from 'components/Store';

const V2_RESOURCE_NAMES = {
  plan: 'plans',
  plans: 'plans',
  'plan/plansummaries': 'plans/summaries'
};

export const selectPlanServiceApi = (
  flags,
  globalFlagKey,
  byOrgFlagKey,
  organizationId,
  apiV1,
  apiV2
) =>
  featureFlagRenderItem(
    flags[globalFlagKey],
    flags[byOrgFlagKey],
    organizationId
  )
    ? apiV2
    : apiV1;

const usePlanServiceApi = (resourceName, globalFlagKey, byOrgFlagKey) => {
  const [apiV1] = useState(() =>
    genResource(resourceName, `${CROPWISE_PROXY_URL}/v1`)
  );
  const v2ResourceName = V2_RESOURCE_NAMES[resourceName] || resourceName;
  const [apiV2] = useState(() =>
    genResource(v2ResourceName, CROPWISE_PROXY_V2_URL)
  );
  const [{ organization }] = useContext(Context);
  const flags = useFlags();
  return selectPlanServiceApi(
    flags,
    globalFlagKey,
    byOrgFlagKey,
    organization?.id,
    apiV1,
    apiV2
  );
};

export default usePlanServiceApi;
